import React, { useId, useState, useRef, useEffect } from 'react';

import { useInView } from "react-intersection-observer";

import { motion } from 'framer-motion';

import { graphql, useStaticQuery } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';

import Typography from '@mui/material/Typography';

import { fonts } from '../gatsby-theme-material-ui-top-layout/theme';

import styled from 'styled-components';

import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

// natalia, anna, eric, javante, paulina, jessica, kirsten, alyse, ilko, shay,
import TeamMemberNatalia from '../img/team-natalia.png';
import TeamMemberAnna from '../img/team-anna.png';
import TeamMemberEric from '../img/team-eric.png';
import TeamMemberJavante from '../img/team-javante.png';
import TeamMemberPaulina from '../img/team-paulina.png';
import TeamMemberJessica from '../img/team-jessica.png';
import TeamMemberKirsten from '../img/team-kirsten.png';
import TeamMemberAlyse from '../img/team-alyse.png';
import TeamMemberIlko from '../img/team-ilko.png';
import TeamMemberShay from '../img/team-shay.png';
// import TeamMemberElias from '../img/team-elias.png';
import TeamMemberGabriella from '../img/team-gabriella.png';
import TeamMemberLauren from '../img/team-lauren.png';
import TeamMemberVictoria from '../img/team-victoria.png';
// import TeamMemberJulie from '../img/team-julie.png'

import ContactIconCalendar from '../img/contact-icon-calendar.svg';
import ContactIconPhone from '../img/contact-icon-phone.svg';

import ArrowHorizontal from '../img/arrow-horizontal.svg';

import LinkWrapper from './LinkWrapper';

import {
  PROPY_SPACE_GREY_LIGHT,
  PROPY_BLACK,
  PROPY_LIGHT_BLUE,
} from '../utils';

const ZoneContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Zone = styled.div`
  max-width: 1080px;
  width: 100%;
`

const TypographyWithControlsContainer = styled.div`
  margin-bottom: ${props => props.theme.spacing(8)};
  display: flex;
  justify-content: space-between;
`

const TypographyContainer = styled.div`
  max-width: ${props => props.mobile ? '300px' : '1060px'};
  margin-left: ${props => props.mobile ? 'auto' : '0px'};
  margin-right: ${props => props.mobile ? 'auto' : '0px'};
`

const Controls = styled.div`
  display: flex;
  align-items: end;
`

const ScrollTrack = styled.div`
  display: flex;
  width: fit-content;
  transform: translate3d(${props => {
    return (props.totalOffset > props.maxTotalOffset) ? props.totalOffset : props.maxTotalOffset
  }}px, 0, 0);
  transition: transform 0.1s linear;
  will-change: transform;
`;

const TypographySpacer = styled.div`
  margin-top: ${props => props.theme.spacing(1.5)};
`

const ImageRowContainer = styled(motion.div)`
  display: flex;
  position: relative;
  overflow-x: visible;
  padding-left: ${props => props.mobile ? props.theme.spacing(2) : '0px'};
  padding-right: ${props => props.mobile ? props.theme.spacing(2) : '0px'};
  padding-bottom: ${props => props.mobile ? props.theme.spacing(2) : '0px'};
`

const ImageContainer = styled.div`
  margin-right: ${props => props.mobile ? props.theme.spacing(2) : props.theme.spacing(4)};
  text-align: center;
`

const MobileControls = styled.div`
  margin-top: ${props => props.theme.spacing(1.5)};
  display: flex;
  justify-content: center;
`

const ContactIconContainer = styled.div`
  background-color: ${PROPY_LIGHT_BLUE};
  border-radius: 100%;
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 155px;
  left: ${props => props.type === 'phone' ? '70%' : '5%'};
`

const SINGLE_ENTRY_WIDTH = 180;
const SINGLE_ENTRY_MARGIN_RIGHT = 32;
const COMBINED_ENTRY_WIDTH = SINGLE_ENTRY_WIDTH + SINGLE_ENTRY_MARGIN_RIGHT;

const SINGLE_ENTRY_WIDTH_MOBILE = 180;
const SINGLE_ENTRY_MARGIN_RIGHT_MOBILE = 16;
const COMBINED_ENTRY_WIDTH_MOBILE = SINGLE_ENTRY_WIDTH_MOBILE + SINGLE_ENTRY_MARGIN_RIGHT_MOBILE;

const teamMembers = [
  {
    name: "Natalia Karayaneva",
    image: TeamMemberNatalia,
    title: "Propy CEO & President of Propy Title",
  },
  {
    name: "Anna Atencio",
    image: TeamMemberAnna,
    title: "Propy Title CEO",
  },
  {
    name: "Eric L. Cruz",
    image: TeamMemberEric,
    title: "VP of Sales",
  },
  {
    name: "Jessica Carter",
    image: TeamMemberJessica,
    title: "Sr. Escrow Officer",
    location: "Florida",
    contacts: [
      {
        type: "phone",
        value: "tel:+18135864511",
      }
    ]
  },
  {
    name: "Kirsten Heslop",
    image: TeamMemberKirsten,
    title: "Escrow Officer",
    location: "Arizona",
    contacts: [
      {
        type: "phone",
        value: "tel:+16028130536",
      }
    ]
  },
  {
    name: "Alyse Caro",
    image: TeamMemberAlyse,
    title: "Escrow Officer",
    location: "Colorado",
    contacts: [
      {
        type: "phone",
        value: "tel:+13038657266",
      }
    ]
  },
  {
    name: "Shay Sandifer",
    image: TeamMemberShay,
    title: "Escrow Assistant",
    location: "Arizona",
    additionalInfo: "Yo hablo Español",
    contacts: [
      {
        type: "phone",
        value: "tel:+16027262469",
      }
    ]
  },
  {
    name: "Ilko Boyadjiev",
    image: TeamMemberIlko,
    title: "Sr. Account Executive",
    contacts: [
      {
        type: "phone",
        value: "tel:+18137615915",
      },
      {
        type: "calendar",
        value: "https://meetings.hubspot.com/propycs/homepage-ilko",
      }
    ]
  },
  {
    name: "Paulina Sherwood",
    image: TeamMemberPaulina,
    title: "Sr. Account Executive",
    contacts: [
      {
        type: "phone",
        value: "tel:+14807574097",
      },
      {
        type: "calendar",
        value: "https://meetings.hubspot.com/paulina90/homepage-paulina",
      }
    ]
  },
  {
    name: "Gabriella van Eijk",
    image: TeamMemberGabriella,
    title: "Account Executive",
    contacts: [
      {
        type: "phone",
        value: "tel:+17272558224",
      },
      {
        type: "calendar",
        value: "https://meetings.hubspot.com/gabriella-van-eijk/homepage-gabi",
      }
    ]
  },
  {
    name: "Javante Vasquez",
    image: TeamMemberJavante,
    title: "Account Executive",
    contacts: [
      {
        type: "phone",
        value: "tel:+18137615879",
      },
      {
        type: "calendar",
        value: "https://meetings.hubspot.com/javante/homepage-javante",
      }
    ]
  },
  {
    name: "Lauren Brail",
    image: TeamMemberLauren,
    title: "Account Executive",
    contacts: [
      {
        type: "phone",
        value: "tel:+17276154441",
      },
      {
        type: "calendar",
        value: "https://meetings.hubspot.com/lauren-brail/homepage-lauren",
      }
    ]
  },
  {
    name: "Victoria Niles",
    image: TeamMemberVictoria,
    title: "Account Executive",
    contacts: [
      {
        type: "phone",
        value: "tel:+17273165237",
      },
      {
        type: "calendar",
        value: "https://meetings.hubspot.com/victoria-niles/homepage-victoria",
      }
    ]
  },
  // {
  //   name: "Julie Canty",
  //   image: TeamMemberJulie,
  //   title: "Transaction Coordinator",
  //   contacts: [
  //     {
  //       type: "phone",
  //       value: "tel:+18134458642",
  //     }
  //   ]
  // },
  // {
  //   name: "Elias Leverett",
  //   image: TeamMemberElias,
  //   title: "Account Executive",
  // },
];

const TeamGallery = ({ isConsideredMobile }) => {

  // Query all team member images
  const data = useStaticQuery(graphql`
    query {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { regex: "/^team-/" }
        }
      ) {
        edges {
          node {
            relativePath
            childImageSharp {
              gatsbyImageData(
                width: 180
                # height: 240
                transformOptions: {
                  fit: CONTAIN
                }
                placeholder: BLURRED
                layout: FIXED
                quality: 100
              )
            }
          }
        }
      }
    }
  `);

  const imageMap = data.allFile.edges.reduce((acc, { node }) => {
    const name = node.relativePath.replace(/^team-|\.png$/g, '').toLowerCase();
    acc[name] = getImage(node);
    return acc;
  }, {});

  const teamMembersWithGatsbyImages = teamMembers.map(member => ({
    ...member,
    gatsbyImage: imageMap[member.name.split(' ')[0].toLowerCase()]
  }));

  
  const zoneRef = useRef(null);
  const [imagesPerView, setImagesPerView] = useState(5); // default value
  const [currentIndex, setCurrentIndex] = useState(0);
  const [absolutePositionFromTop, setAbsolutePositionFromTop] = useState(0);
  const [scrollOffset, setScrollOffset] = useState(0);
  const [buttonOffset, setButtonOffset] = useState(0);
  const [maxTotalOffset, setMaxTotalOffset] = useState(0);
  const [hasUsedButton, setHasUsedButton] = useState(false);
  const totalOffset = buttonOffset + scrollOffset;
  const galleryId = useId();

  const { ref, inView, entry } = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if(inView) {
      setAbsolutePositionFromTop(window.scrollY + entry.boundingClientRect.top);
    }
  }, [inView, entry]);

  useEffect(() => {
    const handleScroll = () => {
      if (!inView || hasUsedButton) return;
      
      // Calculate how far we've scrolled past the component
      const scrollPastComponent = (window.scrollY + window.innerHeight) - absolutePositionFromTop;
      
      // Only start translating after we've scrolled past the component
      if (scrollPastComponent > 0) {
        const newBaseOffset = -scrollPastComponent * (isConsideredMobile ? 0.25 : 0.5);
        
        const combinedOffset = newBaseOffset;
        if (
          combinedOffset <= 0
        ) {
          setScrollOffset(combinedOffset);
        }
      } else {
        setScrollOffset(0);
      }
    };
  
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [inView, entry, absolutePositionFromTop, isConsideredMobile, hasUsedButton]);

  // Calculate visible images on mount and resize
  useEffect(() => {
    const calculateVisibleImages = () => {
      if (!zoneRef.current) return;
      
      const zoneWidth = zoneRef.current.offsetWidth;
      const totalImageWidth = isConsideredMobile ? COMBINED_ENTRY_WIDTH_MOBILE : COMBINED_ENTRY_WIDTH;
      
      // Calculate how many whole images fit
      const visibleImages = Math.floor(zoneWidth / totalImageWidth);
      const maxTotalOffset = ((isConsideredMobile ? COMBINED_ENTRY_WIDTH_MOBILE * teamMembers.length : COMBINED_ENTRY_WIDTH * teamMembers.length) - (isConsideredMobile ? COMBINED_ENTRY_WIDTH_MOBILE * visibleImages : COMBINED_ENTRY_WIDTH * visibleImages)) * -1;
      console.log({maxTotalOffset})
      setImagesPerView(visibleImages);
      setMaxTotalOffset(maxTotalOffset);
    };

    calculateVisibleImages();
    
    // Add resize listener
    window.addEventListener('resize', calculateVisibleImages);
    return () => window.removeEventListener('resize', calculateVisibleImages);
  }, [isConsideredMobile]);

  const isAtEnd = () => {
    return currentIndex + imagesPerView >= teamMembers.length;
  };

  const handleNext = () => {
    if (!isAtEnd()) {
      const remainingImages = teamMembers.length - currentIndex - imagesPerView;
      const scrollCount = remainingImages < imagesPerView ? remainingImages : imagesPerView;
      let newButtonOffset = (currentIndex + scrollCount) * (isConsideredMobile ? COMBINED_ENTRY_WIDTH_MOBILE : COMBINED_ENTRY_WIDTH) * -1;
      setHasUsedButton(true);
      setButtonOffset(newButtonOffset);
      setCurrentIndex(prev => prev + scrollCount);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      const scrollCount = Math.min(imagesPerView, currentIndex);
      let newButtonOffset = (currentIndex - scrollCount) * (isConsideredMobile ? COMBINED_ENTRY_WIDTH_MOBILE : COMBINED_ENTRY_WIDTH) * -1;
      setHasUsedButton(true);
      if((currentIndex - scrollCount) > 0) {
        setButtonOffset(newButtonOffset);
        setCurrentIndex(prev => prev - scrollCount);
      } else {
        setButtonOffset(0);
        setCurrentIndex(0);
        setScrollOffset(0);
      }
    } else {
      setButtonOffset(0);
      setCurrentIndex(0);
      setScrollOffset(0);
    }
  };

  return (
    <ZoneContainer>
      <Zone ref={zoneRef}>
        <TypographyContainer mobile={isConsideredMobile}>
           <Typography sx={{ textTransform: 'uppercase', fontFamily: fonts.spaceGrotesk, color: PROPY_SPACE_GREY_LIGHT, letterSpacing: '0.12em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '14px', lineHeight: '14px' }) }}>Meet the Experts</Typography>
           <TypographySpacer>
             <TypographyWithControlsContainer>
                <Typography variant="h4" sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_BLACK, letterSpacing: '-0.01em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '24px', lineHeight: '24px' }) }}>Our team is committed to delivering top-notch service and innovation.</Typography>
                {!isConsideredMobile &&
                  <Controls>
                    <IconButton
                      onClick={handlePrev}
                      disabled={currentIndex === 0 && !(totalOffset < -20)}
                      sx={{
                        border: '1px solid #38A6FB',
                        height: '44px',
                        width: '44px',
                        marginRight: '8px',
                        opacity: (currentIndex === 0 && !(totalOffset < -20)) ? 0.5 : 1,
                      }} 
                      aria-label="backwards"
                    >
                      <Box
                        component={ArrowHorizontal}
                        sx={{
                          width: '24px',
                          height: '24px',
                          color: 'primary.main',
                          '& path': { fill: '#38A6FB' }
                        }}
                      />
                    </IconButton>
                    <IconButton
                      onClick={handleNext}
                      disabled={isAtEnd()} // Updated condition here
                      sx={{
                        border: '1px solid #38A6FB',
                        height: '44px',
                        width: '44px',
                        opacity: isAtEnd() ? 0.5 : 1, // And here
                      }}
                      aria-label="forwards"
                    >
                      <Box
                        component={ArrowHorizontal}
                        sx={{
                          width: 24,
                          height: 24,
                          transform: 'rotate(180deg)',
                          color: 'primary.main',
                          '& path': { fill: '#38A6FB' }
                        }}
                      />
                    </IconButton>
                  </Controls>
                }
            </TypographyWithControlsContainer>
          </TypographySpacer>
        </TypographyContainer>
        <ImageRowContainer mobile={isConsideredMobile}>
          <ScrollTrack totalOffset={totalOffset} maxTotalOffset={maxTotalOffset} mobile={isConsideredMobile}>
            {teamMembersWithGatsbyImages.map((teamMember, index) => (
              <ImageContainer mobile={isConsideredMobile} key={`${galleryId}-${index}-linear`}>
                <motion.div
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.3 }}
                  style={{position: 'relative'}}
                >
                  <GatsbyImage
                    image={teamMember.gatsbyImage}
                    alt={teamMember.name}
                    style={{
                      borderRadius: '8px',
                      marginBottom: '16px',
                    }}
                  />
                  {teamMember.contacts?.length > 0 && teamMember.contacts.map((contact, index) =>
                    <LinkWrapper external={true} link={contact.value} key={`team-member-contact-icon-${contact.type}-${index}-${teamMember.name}`}>
                      <ContactIconContainer type={contact.type}>
                        {contact.type === 'calendar' && 
                          <Box
                            component={ContactIconCalendar}
                          />
                        }
                        {contact.type === 'phone' && 
                          <Box
                            component={ContactIconPhone}
                          />
                        }
                      </ContactIconContainer>
                    </LinkWrapper>
                  )}
                </motion.div>
                <Typography 
                  style={{
                    color: PROPY_BLACK, 
                    letterSpacing: '0.04em', 
                    fontSize: 12
                  }} 
                  sx={{ 
                    fontFamily: fonts.spaceGrotesk, 
                    fontWeight: 500, 
                    textTransform: 'uppercase' 
                  }}
                >
                  {teamMember.name}
                </Typography>
                <Typography 
                  style={{
                    color: PROPY_SPACE_GREY_LIGHT, 
                    letterSpacing: '0.04em', 
                    fontSize: 12
                  }} 
                  sx={{ 
                    fontFamily: fonts.spaceGrotesk, 
                    fontWeight: 400, 
                    textTransform: 'uppercase' 
                  }}
                >
                  {teamMember.title}
                  {teamMember.location && <><br/>{teamMember.location}</>}
                </Typography>
              </ImageContainer>
            ))}
          </ScrollTrack>
        </ImageRowContainer>
        <div ref={ref} />
        {isConsideredMobile &&
          <MobileControls>
            <Controls>
              <IconButton
                onClick={handlePrev}
                disabled={currentIndex === 0 && !(totalOffset < -20)}
                sx={{
                  border: '1px solid #38A6FB',
                  height: '44px',
                  width: '44px',
                  marginRight: '8px',
                  opacity: (currentIndex === 0 && !(totalOffset < -20)) ? 0.5 : 1,
                }} 
                aria-label="backwards"
              >
                <Box
                  component={ArrowHorizontal}
                  sx={{
                    width: '24px',
                    height: '24px',
                    color: 'primary.main',
                    '& path': { fill: '#38A6FB' }
                  }}
                />
              </IconButton>
              <IconButton
                onClick={handleNext}
                disabled={isAtEnd()}
                sx={{
                  border: '1px solid #38A6FB',
                  height: '44px',
                  width: '44px',
                  opacity: isAtEnd() ? 0.5 : 1,
                }}
                aria-label="forwards"
              >
                <Box
                  component={ArrowHorizontal}
                  sx={{
                    width: 24,
                    height: 24,
                    transform: 'rotate(180deg)',
                    color: 'primary.main',
                    '& path': { fill: '#38A6FB' }
                  }}
                />
              </IconButton>
            </Controls>
          </MobileControls>
        }
      </Zone>
    </ZoneContainer>
  );
};

export default TeamGallery;